import React, { FC, useEffect, useMemo, useState } from 'react'
import { IonPage, IonContent } from '@ionic/react'
import { observer } from 'mobx-react'
import { cartMobx, deskMobx, queueMobx, storeMobx } from 'restaurant'
import { memberMobx, themeMobx } from '@mobxStore'
import { toast, useHistoryNew } from '@utils'
import { localStore, addParams } from '@dt/fe-utils'
import { DiningNumberPickController, DeskAreaPickController } from '@ctrls/index'
import { Icon, UsernameInput } from '@cps'
import './index.scss'

const headPic = 'https://eshine-image.oss-cn-hangzhou.aliyuncs.com/20220627/92bb6bdb1114d414.png'

// 座位映射关系
const seatMap = {
  1: 1,
  2: 2,
  3: 4,
  4: 4,
  5: 6,
  6: 6,
  7: 8,
}

interface IProps {
}

interface IState {
  person: number;
  kids: number;
  contactName: string;
  countryCode: number;
  contactMobile: string;
  memberId?: string;
  seatAreaId?: number;
  seatAreaName?: string;
}

const Queue: FC<IProps> = ({ }) => {
  const { showTabs } = themeMobx
  const { info: store } = storeMobx
  const { queueConfig, queueInfo } = queueMobx
  const [formData, setFormData] = useState<IState>({
    person: 0,
    kids: 0,
    contactName: '',
    countryCode: bo === 'cn' ? 86 : 1,
    contactMobile: '',
  })
  const [kbOffSet, setKbOffSet] = useState(0)
  const hasHome = showTabs?.find(item => item.type === 'home')
  const history = useHistoryNew()

  // desk areas
  const deskAreas = useMemo(() => {
    const areas = deskMobx.areas?.filter(item => {
      return item.desks?.some(d => d.seat === seatMap[formData.person]) || (formData.person > 7 && item.desks?.some(d => d.seat === 8))
    })
    if (areas?.length) {
      areas.unshift({
        id: 0,
        name: i18n.t('queue.plSelect')
      })
    }
    return areas
  }, [deskMobx.areas, formData.person])

  // 是否开通
  const isOpen = useMemo(() => {
    return !!queueConfig.isOpen && !!store.saleResourceInfo?.queue
  }, [queueConfig.isOpen, store.saleResourceInfo])

  // 排队未开通
  const renderNoOpen = () => (
    <div className='qc-rule'>
      <div>{i18n.t('queue.noOpen1')}</div>
      <div>{i18n.t('queue.noOpen2')}</div>
    </div>
  )

  // 排队规则
  const renderRule = () => (
    <div className='qc-rule'>
      <div>{i18n.t('queue.rule1')}</div>
      <div>{i18n.t('queue.rule2', { time: queueConfig.recallMin, count: queueConfig.recallPassSeat })}</div>
      <div>{i18n.t('queue.rule3', { count: queueConfig.recallCnt })}</div>
    </div>
  )

  // 表单数据
  const renderForm = () => (
    <div className='qc-form'>
      <div className='input-item'>
        <label>{i18n.t('queue.person')}</label>
        <div className='input' onClick={handleShowPeronPick}>
          <Icon size={20} name='jiucanrenshu' />
          <span className='person'>{formData.person ? i18n.t('queue.personNum', { num: formData.person }) : ''}</span>
        </div>
      </div>
      <div className='input-item'>
        <label>{i18n.t('queue.nickName')}</label>
        <input
          className='input'
          value={formData.contactName}
          onChange={(e) => {
            setFormData({
              ...formData,
              contactName: e.target.value
            })
          }}
          placeholder={i18n.t('mkt.common.tipNickName')}
        />
      </div>
      <div className='input-item'>
        <label>{i18n.t('queue.mobile')}</label>
        <UsernameInput
          value={{
            pass: formData.contactMobile,
            countryCode: formData.countryCode,
          }}
          inputType='mobile'
          placeholder={i18n.t('mkt.common.tipMobile')}
          onChange={(data) => {
            setFormData({
              ...formData,
              contactMobile: data.pass,
              countryCode: data.countryCode,
            })
          }}
          onGetTop={(top: number) => {
            setKbOffSet(top)
          }}
        />
      </div>
      {
        deskAreas?.length ? (
          <div className='input-item'>
            <label>{i18n.t('queue.desk')}<small>{i18n.t('queue.optional')}</small></label>
            <div className='input' onClick={handleShowDeskPick}>{formData.seatAreaName}</div>
          </div>
        ) : null
      }
    </div>
  )

  // 去预点单
  const handleToOrder = (queueId: number) => {
    const _url = addParams({
      url: location.href.replace(/\/queue/, '/menu'),
      params: { queueId }
    })
    localStore.set(`ls.queueId.${storeMobx.info.brandId}.${storeMobx.info.storeId}`, queueId)
    location.replace(_url)
  }

  // 返回
  const handleBack = () => {
    history.replace(hasHome ? '/home' : '/menu')
  }

  // 就餐人数
  const handleShowPeronPick = () => {
    DiningNumberPickController.showPicker()
  }

  // 座位要求
  const handleShowDeskPick = () => {
    if (!deskAreas?.length) return
    const deskPick = new DeskAreaPickController()
    deskPick.showPicker({
      areas: deskAreas,
      areaId: formData.seatAreaId,
      callback: (data) => {
        setFormData({
          ...formData,
          seatAreaId: data.value,
          seatAreaName: data.value ? data.text : ''
        })
      }
    })
  }

  // 完成取号
  const handleSubmit = async () => {
    const { contactName, contactMobile, person } = formData
    if (!person) {
      toast({ message: i18n.t('queue.inputPerson') })
      return
    }
    if (!contactName) {
      toast({ message: i18n.t('queue.inputName') })
      return
    }
    if (!contactMobile) {
      toast({ message: i18n.t('queue.inputMobile') })
      return
    }
    try {
      if (!formData.seatAreaId) {
        formData.seatAreaId = undefined
        formData.seatAreaName = undefined
      }
      const res = await queueMobx.callNono(formData)
      if (!res?.error) {
        handleToOrder(res.callId)
      } else {
        toast({ message: res?.error?.message })
      }
    } catch (error) {
      toast({ message: error.message })
    }
  }

  // 前往预点单
  const handleToPreOrder = () => {
    const _url = addParams({
      url: location.href.replace(/\/queue/, '/menu'),
      params: { ot: 'preOrder' }
    })
    location.replace(_url)
  }

  // useEffect
  useEffect(() => {
    cartMobx.setPerson(0)
    queueMobx.init()
    deskMobx.init()
  }, [])

  // 没有开启排队，就前往预点单
  useEffect(() => {
    if (Object.keys(queueConfig).length && !isOpen) {
      handleToPreOrder()
    }
  }, [queueConfig])

  useEffect(() => {
    const _data = { ...formData }
    const { person, kids } = cartMobx.info
    person && (_data.person = person)
    kids && (_data.kids = kids)
    if (person !== formData.person) {
      _data.seatAreaId = 0
      _data.seatAreaName = ''
    }
    setFormData({ ..._data })
  }, [cartMobx.info.person, cartMobx.info.kids])

  useEffect(() => {
    const _data = { ...formData }
    const { nickName, countryCode, mobile, memberId } = memberMobx.memberInfo
    nickName && (_data.contactName = nickName)
    countryCode && (_data.countryCode = countryCode)
    mobile && (_data.contactMobile = mobile)
    memberId && (_data.memberId = String(memberId))
    setFormData({ ..._data })
  }, [memberMobx.memberInfo])

  useEffect(() => {
    const { callId, status } = queueInfo
    if (callId && status !== 'Pass') {
      handleToOrder(callId)
    }
  }, [queueInfo])

  return (
    <IonPage className='queue-page'>
      <IonContent className='queue-content' style={{ '--keyboard-offset': `${kbOffSet}px` }}>
        {isOpen && <img className='qc-head' src={headPic} />}
        {
          isOpen && (
            <div className='qc-content'>
              <h3 className='qc-title'>{i18n.t('pageName.queue')}</h3>
              {renderRule()}
              {renderForm()}
              <div className='qc-btn' onClick={handleSubmit}>{i18n.t('queue.submitToOrder')}</div>
            </div>
          )
        }
      </IonContent>
    </IonPage>
  )
}

export default observer(Queue)
